import React from "react";
import styled from "styled-components/native";
import { SpaceType } from "../Spacer/types";

const Index = ({ size }: { size: SpaceType }) => {
  return <Space size={size} />;
};

const Space = styled.View<{ size: SpaceType }>`
  height: ${({ size }: { size: SpaceType }) => size}px;
  width: ${({ size }: { size: SpaceType }) => size}px;
`;

export default Index;
